/* import __COLOCATED_TEMPLATE__ from './menu-panel.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./menu-panel.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());